import { render, staticRenderFns } from "./conferenceProfile.vue?vue&type=template&id=ecc0e0fe&scoped=true&"
import script from "./conferenceProfile.vue?vue&type=script&lang=js&"
export * from "./conferenceProfile.vue?vue&type=script&lang=js&"
import style0 from "./conferenceProfile.vue?vue&type=style&index=0&id=ecc0e0fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc0e0fe",
  null
  
)

export default component.exports